module.exports = __webpack_public_path__ + "static/media/logo-ORE-color-@2x.d46b5f47.png";